import dayjs from 'dayjs';
import i18next from 'i18next';
import { UnitType } from '@api/generated/search-service';

export const formatMoney = (price: number, currency: string = 'Kč'): string => {
  return `${price?.toLocaleString('cs', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'} ${currency}`;
};

export const formatAmountPlain = (amount: number): string => {
  return `${amount?.toLocaleString('cs', { minimumFractionDigits: 0, maximumFractionDigits: 3 }) || '-'}`;
};

export const formatPercentage = (price: number): string => {
  return `${price?.toLocaleString('cs', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) || '-'} %`;
};

export const formatDateTime = (date: string): string => {
  if (!date) return '';
  return dayjs.utc(date).local().format('D. M. YYYY H:mm');
};

export const formatDate = (date: string | undefined): string => {
  if (!date) return '';
  return dayjs.utc(date).local().format('D. M. YYYY');
};

export const formatTime = (date: string | undefined): string => {
  if (!date) return '';
  return dayjs.utc(date).local().format('H:mm');
};

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatPriceGuarantee = (from: string, to: string): string => {
  const label = i18next.t('client:formats.priceGuarantee');
  if (from === to) {
    return `${label}: ${from}`;
  }
  return `${label}: ${formatDate(from)} - ${formatDate(to)}`;
};

export const formatPricePerUnit = (price: number, unit: UnitType = 'KUS'): string => {
  return `${formatMoney(price)}/${formatUnit(unit)}`;
};

export const formatAmount = (auctionAmount: number, auctionUnit: UnitType) => {
  return `${auctionAmount?.toLocaleString('cs', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) || '-'} ${auctionUnit}`;
};

export const formatBoolean = (b: boolean) => {
  return b ? i18next.t('client:formats.yes') : i18next.t('client:formats.no');
};

export const formatUnit = (unit: UnitType): string => {
  return i18next.t(`client:formats.unit.${unit}`, { defaultValue: unit });
};

export const mapToApi = (date: Date): string => {
  return dayjs(date).format('YYYY-MM-DD');
};

export const formatAuctionPrice = (price: number, auctionAmount: number, unit: UnitType) => {
  return `${formatMoney(price)}/${auctionAmount !== 1 ? `${auctionAmount} ` : ''}${formatUnit(unit)}`;
};
